import { isStaleDataStripVisible } from '../../../../common/StaleDataStrip/staleDataStripUtils';
import { useStaleDataStrip } from '../../../../common/StaleDataStrip/useStaleDataStrip';
import { useMobileRefreshButtonLogic } from '../MobileRefreshButton/useMobileRefreshButtonLogic';

export function useMobileStaleDataStripLogic() {
    const refresh = useMobileRefreshButtonLogic();
    const copy = useStaleDataStrip();

    return {
        ...refresh,
        copy,
        isVisible: isStaleDataStripVisible({ copy, isFetchingData: refresh.isFetching, shouldDisableUnlock: refresh.shouldDisableUnlock }),
    };
}
